import { Services } from '@sigma-frontend-libs/commons'
import { MODERATION_VALUES } from '@sigma-legacy-libs/essentials/lib/constants'

import { components, labelModes, moderationColors, moderationIcons } from '@/utils'

import selectorOwner from '@/components/selector/owner'
import selectorSendingType from '@/components/selector/sendingType'
import tag from '@/components/tag'

export default function(h) {
  let cols = 2
  if (this.canGetUsersAsResellerUp) {
    cols = 3
  }

  let gridTemplateColumns = '1fr'
  if (this.viewport.breakpoint.mdUp) {
    gridTemplateColumns = `repeat(${cols}, minmax(170px, 200px))`
  }

  return h(
    'div',
    {
      class: `${Services.sendernames}-filter`,
      style: { 'grid-template-columns': gridTemplateColumns }
    },
    [
      h(
        selectorSendingType,
        {
          props: {
            value: this.proxy.type,
            label: this.getTranslate(`${Services.sendernames}.labels.type`),
            permission: `advanced.${Services.sendernames}.get`
          },
          on: {
            input: event => {
              this.proxy.type = event
            }
          }
        }
      ),
      h(
        components.select,
        {
          props: {
            value: this.proxy.moderation,
            label: this.getTranslate(`${Services.sendernames}.labels.moderation`),
            items: MODERATION_VALUES.map(value => {
              return {
                title: this.getTranslate(`misc.moderation.${value}`),
                icon: moderationIcons[value],
                iconColor: moderationColors[value],
                value
              }
            }),
            labelMode: labelModes.hidden,
            dense: true,
            clearable: true,
            details: false
          },
          scopedSlots: {
            selection: ({ item }) => {
              return h(
                tag,
                {
                  props: {
                    label: this.getTranslate(`misc.moderation.${item.value}`),
                    color: moderationColors[item.value],
                    as: 'select-dense'
                  }
                }
              )
            }
          },
          on: {
            input: event => {
              this.proxy.moderation = event
            }
          }
        }
      ),

      h(
        selectorOwner,
        {
          props: {
            value: this.proxy.OwnerId,
            labelMode: labelModes.hidden,
            dense: true
          },
          on: {
            input: event => {
              this.proxy.OwnerId = event
            }
          }
        }
      )
    ]
  )
}
